module.exports = __webpack_public_path__ + "c524927d79827ea78651d3a1148243c5.png";